export default {
  // 企業情報
  PAGE_TITLE: "Company information",
  COMPANY_INFO: "Company information",
};
